<template>
  <div class="account-settings">
    <Header />
    <div class="settings-main">
      <SettingsNavigation></SettingsNavigation>
      <div class="email">
        <div class="email-main">
          <p class="indentation">
            Want to change your email address? No problem. Just enter your new
            address and password below and click the “Change Email” button.
          </p>
          <p>
            We’ll send a confirmation email to you right away. When it arrives,
            you must click the link inside to confirm it’s really you making
            this request. (Just a little precaution!)
          </p>
          <div class="wide">
            If we don’t hear from you, we’ll suspend your account for your
            protection.
          </div>
          <div class="info">Current Email Address</div>
          <div class="info">001****2345@qq.com</div>
          <div class="input-boxs">
            <div>New E mail Address</div>
            <input type="text" />
          </div>
          <div class="input-boxs">
            <div>Password</div>
            <input type="text" />
          </div>
          <div :class="['update', { 'update-check': checked }]" @click="submit">
            <div>Change Email</div>
          </div>
        </div>
        <Account></Account>
      </div>
      <AvatarUrl></AvatarUrl>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import SettingsNavigation from "./mycom/settingsNavigation.vue";
import AvatarUrl from "./mycom/avatarUrl.vue";
import Account from "./mycom/account.vue";
export default {
  components: { Header, Footer, SettingsNavigation, AvatarUrl, Account },
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    submit() {
      this.checked = true;
    },
  },
};
</script>
<style scoped>
.account-settings {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.settings-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
  display: flex;
}
.email {
  width: 100%;
}
.email-main {
  width: 337.5px;
  margin-left: 40.625px;
}
.email-main > p {
  font-size: 10px;
  color: #232323;
  margin-bottom: 15px;
  line-height: 15px;
}
input {
  width: calc(100% - 11.25px);
  height: 21.25px;
  line-height: 21.25px;
  border-radius: 1.25px;
  border: 0.625px solid #dddddd;
  padding-left: 10px;
  font-size: 10px;
}
.input-boxs > div {
  font-size: 10px;
  margin-bottom: 7px;
  margin-top: 20px;
}
.explain {
  margin-top: 12.5px;
  font-size: 10px;
  line-height: 15px;
  margin-bottom: 12.5px;
}
.wide {
  font-weight: bold;
  font-size: 10px;
  line-height: 15px;
  margin-bottom: 22.5px;
}
.info {
  font-size: 10px;
  margin-bottom: 10px;
}
.update {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.update > div {
  width: 81.875px;
  height: 22.5px;
  border-radius: 1.5px;
  border: 0.625px solid #2e67ea;
  text-align: center;
  line-height: 22.5px;
  margin-top: 30px;
  color: #2e67ea;
  font-size: 10px;
  cursor: pointer;
}
.update-check > div {
  background-color: #2e67ea;
  color: #fff;
}
.indentation{
    text-indent: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/email.vue